import React from 'react'

interface EmojiProps {
    emoji: string
    size?: number | string
    wrapperStyle?: React.CSSProperties
    count?: number
    countStyle?: React.CSSProperties
}

const Emoji: React.FC<EmojiProps> = ({
    emoji,
    size = '1rem',
    wrapperStyle = {},
    count,
    countStyle = {}
}) => (
    <div
        className="relative d-flex align-items-center"
        style={{
            ...wrapperStyle,
            overflow: 'hidden'
        }}
    >
        <span
            className="emoji text-center"
            style={{ fontSize: size }}
        >
            {emoji}
        </span>
        {!!count && <span style={{marginLeft: '0.4rem', ...countStyle}}>{count}</span>}
    </div>
)

export { Emoji }
